import { SPACE } from "../utils/frfr-string-consts";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { draftel_codecs_pack_terkk$_bundle_krov } from "./ter-draftel-codec-lib-terkk-bundle-krov";
import { terUtilsNumberRoundUp } from "./ter-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import tclocal from "./ter-consts-local-lib";
import { _getFromLibMaterijalLimSingleParam } from "./ter-materijal-utils";


export const derDraftel_terkk_krov_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_krov.default_pods_input_state(),
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    duzinamodula: virtel_m.duzinamodula,
    // brojmodula: virtel_m.brojmodula, // ???
    siframodula: virtel_m.siframodula,
  };
  return pods_input_inherited;
};


export const _derivat_krov_izracunaj_povrsinu = (sirina, duzina, tip) => {
  let povrsina = -1;
  if ((sirina > 0 || sirina === 0) && (duzina > 0 || duzina === 0)) {
    let SS;
    let DD;
    /*
    IF Tip "A";((Sirina+90,9)(Duzina+90,9))
    IF Tip"B";((Sirina+90,9)(Visina+63,2))
    IF Tip "C";((Sirina+90,9)(Visina+35,4))
    IF Tip "D Levi";((Sirina+63,2)(Visina+63,2))
    IF Tip "D Desni";((Sirina+63,2)(Visina+63,2))
    IF Tip "E";((Sirina+35,4)(Visina+63,2))
    Za snale - Duzina*42.8
    */
    if (tip === "KROV_A") {
      SS = 90.9;
      DD = 90.9;
      povrsina = ((sirina + SS) * (duzina + DD)) / 1000000; // konvertovana u m2
    } else if (tip === "KROV_B") {
      SS = 90.9;
      DD = 63.2;
      povrsina = ((sirina + SS) * (duzina + DD)) / 1000000; // konvertovana u m2
    } else if (tip === "KROV_C") {
      SS = 63.2;
      DD = 35.4;
      povrsina = ((sirina + SS) * (duzina + DD)) / 1000000; // konvertovana u m2
    } else if (tip === "KROV_D_LEVI" || tip === "KROV_D_DESNI") {
      SS = 63.2;
      DD = 63.2;
      povrsina = ((sirina + SS) * (duzina + DD)) / 1000000; // konvertovana u m2
    } else if (tip === "KROV_E") {
      SS = 35.4;
      DD = 63.2;
      povrsina = ((sirina + SS) * (duzina + DD)) / 1000000; // konvertovana u m2
    }
  }
  if (tip === "KROVNA_SNALA" && (duzina > 0 || duzina === 0)) {
    const _sirina_snale = 42.8;
    povrsina = (duzina * _sirina_snale) / 1000000; // konvertovana u m2
  }
  povrsina = terUtilsNumberRoundUp(povrsina, 2); // povrsinu u m2 zaokruzujemo na 2 decimale
  return povrsina;
};


export const _derivat_krov_izracunaj_naziv = (sirina, duzina, tip, krovniotvor, a, b) => {
  let naziv = '?';
  /*
  Genersisanje naziva na osnovu promenljivih tip krova, dimenzija krova,
  KROV TIP A 1250x1522
  KROV TIP A 1250x1522 OTVOR 500x458
  SNALA ZA KROV 1544 mm
  */
  if (tip === "KROVNA_SNALA") {
    naziv = 'SNALA ZA KROV' + SPACE + duzina + 'mm';
  } else {
    let _oznaka = '';
    if (tip === "KROV_A") {
      _oznaka = 'A';
    } else if (tip === "KROV_B") {
      _oznaka = 'B';
    } else if (tip === "KROV_C") {
      _oznaka = 'C';
    } else if (tip === "KROV_D_LEVI") {
      _oznaka = 'D LEVI';
    } else if (tip === "KROV_D_DESNI") {
      _oznaka = 'D DESNI';
    } else if (tip === "KROV_E") {
      _oznaka = 'E';
    }
    naziv = 'KROV TIP' + SPACE + _oznaka + SPACE + sirina + 'x' + duzina;
    if (krovniotvor === "DA") {
      naziv += SPACE + 'OTVOR' + SPACE + a + 'x' + b;
    }
  }
  return naziv;
};


const _izracunaj_multitranslator_lang = (subDraftel) => {
  let lang = "terkk$krov/child_abcde";
  if (subDraftel.tipkrovnogsegmenta === "KROVNA_SNALA") {
    lang = "terkk$krov/snala";
  }
  return lang;
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_krov_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    // p: p,
    termaterijal: p.termaterijal,
  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_krov_children = (v_input, _unbundled_subDraftel_arr) => {
  console.log('derAutoCreateVirbom_terkk_krov_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterSubdraftelArrItem = 0;
  console.log(typeof _unbundled_subDraftel_arr);
  console.log(Array.isArray(_unbundled_subDraftel_arr));
  console.log(_unbundled_subDraftel_arr);
  _unbundled_subDraftel_arr.forEach((subDraftel) => {
    // EACH
    _counterSubdraftelArrItem++;
    let _derkey = 'der_virtel_child_' + _counterSubdraftelArrItem;

    let _virtelclass_op2_2 = "terkk$krov$child_op2_2";
    let _abxy = {
    };
    if (subDraftel.tipkrovnogsegmenta === "KROVNA_SNALA") {
      _virtelclass_op2_2 = "terkk$krov$child_op2_2_snala";
    } else {
      _abxy = {
        a: null,
        b: null,
        x: null,
        y: null,
      };
    }
    if (subDraftel.krovniotvor === "DA") {
      _abxy = {
        a: subDraftel.a,
        b: subDraftel.b,
        x: subDraftel.x,
        y: subDraftel.y,
      };
    } else {
      // DL 2024-03-05: Ako je krovniotvor NE onda ove dimenzije otovra a, b, x, y mogu da ostanu 0 (nula) da ne izaziva gresku kod CNC programa na osnovu multitranslatora
      _abxy = {
        a: 0,
        b: 0,
        x: 0,
        y: 0,
      };
    }

    // derivat EACH local 1 - OPERACIJA 2. OPSAV ERMAKSAN
    _derivat_key = _derkey;
    const _params_op2 = {
      // "virtelclass": "terkk$krov$child",
      "terkategorija": "PP",
      "tergrupa": "LIM",
      "operacija": "OPSAV",
      "rc": "RCPRSER",
      "angazovanihradnika": 1,
      "vremepripreme": 0,
      "vremeoperacije": 0,
      "vremeugradnje": 0,
      "jm": "kom",
    };
    x = {
      _derivat_key,
      // "virtelclass": "terkk$krov$child",
      "virtelclass": _virtelclass_op2_2,
      virtelschemakey: "terkk$krov$child",
      tip: subDraftel.tipkrovnogsegmenta,
      naziv: subDraftel.naziv,
      sirina: subDraftel.sirina,
      duzina: subDraftel.duzina,
      povrsina: subDraftel.povrsina,
      krovniotvor: subDraftel.krovniotvor,
      ..._abxy,
      kolicina: subDraftel.kolicina,
      termaterijal: v_input.termaterijal,
      multitranslator_lang: _izracunaj_multitranslator_lang(subDraftel),
      ..._params_op2,
      // ..._getParamsFromLib("terkk$krov$child"),
      ..._getParamsFromLib(_virtelclass_op2_2),
    }; // parametri na kraju imaju prioritet
    if (subDraftel.tipkrovnogsegmenta === "KROVNA_SNALA") {
      x.krovniotvor = null;
    }
    x.naziv = _derivat_krov_izracunaj_naziv(x.sirina, x.duzina, x.tip, x.krovniotvor, x.a, x.b);
    x._materijal_naziv = x.naziv + '_m';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // derivat EACH local 1 - OPERACIJA 1. OPSEC AMADA 
    _derivat_key = _derkey + '.1';
    let _virtelclass_op1_2 = "terkk$krov$child_op1_2";
    if (subDraftel.tipkrovnogsegmenta === "KROVNA_SNALA") {
      _virtelclass_op1_2 = "terkk$krov$child_op1_2_snala";
    }
    const _params_op1 = {
      // "virtelclass": "terkk$krov$child",
      "terkategorija": "PP",
      "tergrupa": "LIM",
      "operacija": "OPSEC",
      "rc": "RCPRBAM",
      "angazovanihradnika": 1,
      "vremepripreme": 0,
      "vremeoperacije": 0,
      "vremeugradnje": 0,
      "jm": "kom",
    };
    xx = {
      _derivat_key,
      "virtelclass": _virtelclass_op1_2,
      virtelschemakey: "terkk$krov$child",
      tip: subDraftel.tipkrovnogsegmenta,
      naziv: subDraftel.naziv,
      sirina: subDraftel.sirina,
      duzina: subDraftel.duzina,
      povrsina: subDraftel.povrsina,
      krovniotvor: subDraftel.krovniotvor,
      ..._abxy,
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE,
      termaterijal: v_input.termaterijal,
      cncprogram1: "Lim Krov.S4",
      multitranslator_lang: _izracunaj_multitranslator_lang(subDraftel),
      ..._params_op1,
      // ..._getParamsFromLib("terkk$krov$child"),
      ..._getParamsFromLib(_virtelclass_op1_2),
    }; // parametri na kraju imaju prioritet
    if (subDraftel.tipkrovnogsegmenta === "KROVNA_SNALA") {
      xx.krovniotvor = null;
    }
    xx.naziv = x.naziv;
    xx._materijal_naziv = xx.naziv + '_m';
    z[_derivat_key] = x;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);


    // derivat EACH local 1.1.1
    _derivat_key = _derivat_key + '_m';
    // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    //const _materijal_naziv = xx._materijal_naziv;
    const _materijal_ident = xx.termaterijal; // TODO
    // const _materijal_naziv = x._materijal_naziv;
    const _materijal_naziv = _getFromLibMaterijalLimSingleParam(_materijal_ident, "naziv"); //
    const _kolicina = xx.povrsina; //
    xxm = {
      naziv: _materijal_naziv,
      calculated_ident: _materijal_ident,
      terkategorija: 'M',
      kolicina: _kolicina, // ???
      jm: tclocal.JM_M2,
      //
      _derivat_key,
      // virtelschemakey: 'terkk$ppv$sekcija$materijal1'
      virtelschemakey: 'terkk$materijal_lim'
    };
    z[_derivat_key] = xxm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);


  });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

